<template>
    <ModalComponent
        :name="'editar-patrocinador-' + patrocinador.id"
        title="Editar patrocinador"
        v-on:close="() => close(false)"
    >
        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
            <div class="row">
                <div class="col-12">
                    <FormInput label="Nombre" name="nombre" rules="required" rows="3" v-model="patro.nombre" />
                </div>
                <div class="col-12">
                    <FormInput label="Url" name="url" rules="required" rows="3" v-model="patro.url" />
                </div>
                <div class="col-12 mb-3">
                    <label>Imagen <small>(MEDIDAS: 400X200 - FORMATO: PNG - COLOR: BLANCO - PESO MÁXIMO: Menos de 500 KB)</small></label>
                    <br/>
                    <template v-if="patro.imagen_url">
                        <img :src="patro.imagen_url" style="max-height: 300px"/>
                        <br/>
                        <Button id="boton_borrar" class="mt-1" @click="imagenBorrada">Borrar</Button>
                    </template>
                    <template v-else> 
                        <Dropzone 
                            v-if="url"
                            :url="url"
                            :height="200"
                            :width="400"
                            @success="imagenSubida"
                            @removed="imagenBorrada"
                        />
                    </template>
                </div>
                <div class="col-12 mb-3">
                    <div class="custom-control custom-checkbox">
                        <input class="custom-control-input" type="checkbox" id="show_in_ticket" v-model="patro.show_in_ticket"/>
                        <label for="show_in_ticket" class="custom-control-label">
                            Mostrar en la entrada
                        </label>
                    </div>
                </div>
                <div class="col-12 text-center">
                    <Button type="submit" name="button" :disabled="patro.imagen == null">GUARDAR</Button>
                </div>
            </div>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import Dropzone from '@/components/common/Dropzone';

    export default {
        props: ['patrocinador'],
        data() {
            return {
                loading: false,
                url: this.config.API_BASE + '/upload/image?api_key=' + localStorage.getItem('token') + '&permisos=public',
                patro: Object.assign({}, this.patrocinador)
            }
        },
        methods: {
            close(creado) {
                if(!creado) {
                    this.patro = Object.assign({}, this.patrocinador);
                }                
                this.$emit('close', 'editar-patrocinador-' + this.patrocinador.id, creado);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.crear();
                }
            },
            crear() {
                this.loading = true;
                this.patro.filters = {};
                this.patro.lista_id = this.$store.getters.getListaId;
                this.patro.patrocinador_id = this.patro.id;

                this.$store.dispatch(this.config.getVuexAlias('back.patrocinadores.editar'), this.patro).then(res => {
                    this.expand = [];
                    this.$toast.success(res.data.message);
                    this.close(true);
                }).finally(() => this.loading = false);
            },
            imagenBorrada() {
                this.patro.imagen = null;
                this.patro.imagen_url = null;
            },
            imagenSubida(file, response) {
                this.patro.imagen = response;
            }
        },
        components: {
            ModalComponent, Dropzone
        }
    }
</script>
